module.exports = __webpack_public_path__ + "img/inp_name.42e78930.png";